import axios from "axios";
import { store } from "../index"; // store 경로 맞춰주세요
import { startRefresh, finishRefresh, logout } from "../redux/slices/authSlice";
import { toast } from "react-toastify";
// const T1Url = 'http://0.0.0.0:9000'
// const T2Url = "http://127.0.0.1:9001"
const T1Url = 'https://shinyoung.t1.deeptrade.co'
const T3Url = 'https://shinyoung.t3.deeptrade.co';
// const localUrl = "http://localhost:8000";

const refreshClient = axios.create({
  baseURL: T1Url,
  withCredentials: true,
});

let isRefreshing = false;
let refreshQueue = [];
let hasLoggedOut = false;

function resolveQueue(token) {
  refreshQueue.forEach((cb) => cb(token));
  refreshQueue = [];
}

function handleSessionExpiredOnce() {
  if (hasLoggedOut) return;
  hasLoggedOut = true;

  const toastId = "SESSION_EXPIRED";
  if (!toast.isActive(toastId)) {
    toast.error("세션이 만료되었습니다.", { toastId });
  }
  store.dispatch(logout());
}

export const T1Instance = axios.create({
  baseURL: T1Url,
  withCredentials: true, // refresh 쿠키 자동 전송
});

T1Instance.interceptors.request.use((config) => {
  const token = store.getState().authReducer.accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

T1Instance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    // access 만료 (401) 처리
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;

      // 이미 refresh 진행 중이면, 끝날 때까지 기다렸다가 재시도
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshQueue.push((newToken) => {
            original.headers.Authorization = `Bearer ${newToken}`;
            resolve(T1Instance(original));
          });
        });
      }

      isRefreshing = true;
      store.dispatch(startRefresh());

      try {
        const r = await refreshClient.post("/refresh");
        const newToken = r.data.access_token;

        store.dispatch(finishRefresh(newToken));
        isRefreshing = false;
        resolveQueue(newToken);

        original.headers.Authorization = `Bearer ${newToken}`;
        return T1Instance(original);
      } catch (e) {
        isRefreshing = false;
        resolveQueue(null);

        handleSessionExpiredOnce();

        setTimeout(() => {
          window.location.href = "/";
        }, 5000);

        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);

export const T3Instance = axios.create({
  baseURL: T3Url,
  withCredentials: true, // refresh 쿠키 자동 전송
});

T3Instance.interceptors.request.use((config) => {
  const token = store.getState().authReducer.accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

T3Instance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    // access 만료 (401) 처리
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;

      // 이미 refresh 진행 중이면, 끝날 때까지 기다렸다가 재시도
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshQueue.push((newToken) => {
            original.headers.Authorization = `Bearer ${newToken}`;
            resolve(T3Instance(original));
          });
        });
      }

      isRefreshing = true;
      store.dispatch(startRefresh());

      try {
        const r = await refreshClient.post("/refresh");
        const newToken = r.data.access_token;

        store.dispatch(finishRefresh(newToken));
        isRefreshing = false;
        resolveQueue(newToken);

        original.headers.Authorization = `Bearer ${newToken}`;
        return T3Instance(original);
      } catch (e) {
        isRefreshing = false;
        resolveQueue(null);

        handleSessionExpiredOnce();

        setTimeout(() => {
          window.location.href = "/";
        }, 5000);

        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);

export const shinyongAPI = {
  async runShinyongProcess(formData) {
    const body = JSON.stringify({
      rebalance_date: [formData.targetDate],
      buy_fee: formData.buyFee,
      server: formData.server,
      sell_fee: formData.sellFee,
      tickers: formData.tickers,
      webssh: 'web'
    });
    try {
      // Post to the FastAPI endpoint "/run_process"
      if (formData.server === 'T1') {
        const res = await T1Instance.post("protected/run_process/", body, {
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true
        });
        return res
      } else {

        const res = await T3Instance.post("protected/run_process/", body, {
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true
        });
        return res
      }
    } catch (error) {
      console.error("Error in runShinyongProcess", error);
      throw error;
    }
  },
  async getLog(formData) {
    try {
      if (formData.server === 'T1') {
        const res = await T1Instance.get("protected/get_log", {
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true
        });
        return res.data;
      } else {
        const res = await T3Instance.get("protected/get_log", {
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true
        });
        return res.data;
      }
    } catch (error) {
      console.error("Error in getLog", error);
      throw error;
    }
  },
  async getServerStatus() {
    try {
      const res = await T1Instance.get("protected/server_status", {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      return res.data;
    } catch (error) {
      console.error("Error in getServerStatus", error);
      throw error;
    }
  },
  async getSY_SNP_20() {
    try {
      const res = await T1Instance.get("protected/get_snp_20", {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      return res.data;
    } catch (error) {
      console.error("Error in getSY_SNP_20", error);
      throw error;
    }
  },
  async getSY_SNP_40() {
    try {
      const res = await T1Instance.get("protected/get_snp_40", {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      return res.data;
    } catch (error) {
      console.error("Error in getSY_SNP_40", error);
      throw error;
    }
  },

  async getSY_SNP_ALPHA() {
    try {
      const res = await T1Instance.get("protected/get_snp_alpha", {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      return res.data;
    } catch (error) {
      console.error("Error in getSY_SNP_ALPHA", error);
      throw error;
    }
  },


  async getDBStatus() {
    try {
      const res = await T1Instance.get("protected/db_status", {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
      });
      return res.data;
    } catch (error) {
      console.error("Error in getDBStatus", error);
      throw error;
    }
  },

  async downloadFile(formData) {
    const body = JSON.stringify({
      file_name: formData.downloadFileName,

    });
    try {
      if (formData.server === 'T1') {
        const res = await T1Instance.post("protected/download_file/", body, {
          headers: {
            "Content-Type": "application/json",

          },
          responseType: 'blob',
          withCredentials: true
        });
        return res;
      } else {
        const res = await T3Instance.post("protected/download_file/", body, {
          headers: {
            "Content-Type": "application/json",

          },
          responseType: 'blob',
          withCredentials: true
        });
        return res;
      }
    } catch (error) {
      console.error("Error in getServerStatus", error);
      throw error;
    }
  }
}

export const loginAPI = {
  async dtLogin(formdata) {
    let body = JSON.stringify({
      username: formdata.company_usrnm,
      password: formdata.company_pass,
    });

    return T1Instance.post(`/dtenter/dt_login/`, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  async dtLogout() {
    return T1Instance.post(`/dtenter/dt_logout/`);
  },

  me: async () => T1Instance.get("auth/me"),

  refresh: async () => refreshClient.post("/refresh"),
}

// export const getDtData = {
//   //LIME Macro result
//   async getLimeMacroResult(selectedDate) {
//     let body = JSON.stringify({
//       selectedDate: selectedDate,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_macro/", body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },


//   //Get XAI important features of months

//   async fetchXAIImportantFeaturesResult(selectedDate) {
//     let body = JSON.stringify({
//       selectedDate: selectedDate,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_xai_imp_features/", body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },



//   //Get DT-XAI important features of four months

//   async fetchXAIImpFeatFourMonthResult() {

//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_dt_xai_imp_feat/", {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

//   //Get DT-XAI  Long Short important features of four months

//   async fetchXAILongShortImportanceResult(selectedDate) {
//     let body = JSON.stringify({
//       selectedDate: selectedDate,
//     });

//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_dt_long_short_imp/", body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },


//   //LIME result
//   async getLimeResult(selectedDate) {
//     let body = JSON.stringify({
//       selectedDate: selectedDate,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_lime/", body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

//   async getDBChartData() {
//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .post("dtenter/db_invest_cumpv/", {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },


//   async getDBInvestCurrentData(currentYear) {
//     let body = JSON.stringify({
//       year: currentYear
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/db_invest_current_signal/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

//   //DB 금융투자 시그널 불러오는 api
//   async getDBInvestData(company_name, currentYear) {
//     let body = JSON.stringify({
//       company: company_name,
//       year: currentYear
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/db_invest_signal/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

//   //get Related news

//   async getRelatedNews({ ticker, contains_stock_name }) {
//     let body = JSON.stringify({
//       ticker: ticker,
//       contains_stock_name: contains_stock_name,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`mobile/related/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },
//   async fetchDtData(company_name, currentSelectedDate) {
//     let body = JSON.stringify({
//       company: company_name,
//       date: currentSelectedDate,
//       test: false,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/dt_service/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },
//   async getDTStockInfo(id) {
//     let body = JSON.stringify({
//       id,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/get_dt_stock_info/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

//   //get the stock price

//   async getNewsSummary() {
//     let csrf = await instance.get("mobile/get_csrf/");
//     return instance
//       .get("mobile/get_news_summary/", {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },
// };

// export const getDtData = {
//   async fetchDtData(company_name, modelType, currentSelectedDate) {
//     let body = JSON.stringify({
//       company_name: company_name,
//       model: modelType,
//       date: currentSelectedDate,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/dt_service/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },
//   //New api for test
//   async fetchDtDataTest(company_name, currentSelectedDate) {
//     let body = JSON.stringify({
//       company: company_name,
//       date: currentSelectedDate,
//       test: false,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/dt_service_test/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },
//   async getRiskManagementIndicesData(modelType) {
//     let body = JSON.stringify({
//       type: modelType,
//     });
//     let csrf = await instance.get("mobile/get_csrf/");

//     return instance
//       .post(`dtenter/risk_management_indices/`, body, {
//         headers: {
//           "Content-Type": "application/json",
//           "X-CSRFToken": csrf.data["token"],
//         },
//       })
//       .then((res) => {
//         return res;
//       });
//   },

